__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a4b6da0/_next/";